

const UserDisplay = ({ username }) => {
    return (
        <>

            <div className="end">
                {<label className='userDisplay center'>{username}</label>}
            </div>
        </>
    )
}

export default UserDisplay
